/**
 * Describes Question collection properties
 */
export class Question {
  /** Unique MongoDB document identifier (auto generated by db) */
  public _id: string;
  /** Question is active or not */
  public active: boolean;
  /** Unique question identifier, filled by user */
  public questionId: string;
  /** If question has a defined identifier for 2017 */
  public qNumber2017: string;
  /** If question has a defined identifier for 2018 */
  public qNumber2018: string;
  /** Ambit of the question */
  public Ambito: any;
  /** Groups of the question (based on survey's populations (expansion factors)) */
  public grupos: any;
  /** Topic of the question */
  public topic: string;
  /** Sub topic of the question */
  public subtopic: string;
  /** Topic only for "Compara poblaciones" section */
  public topicPerfiles: string;
  /** Full description of the question */
  public question: string;
  /** Optional comment if question requires a footnote */
  public comment: string;
  /** Name used to sort questions in list */
  public sortName: string;
  /** Short name that describes the question */
  public shortName: string;
  /** Title for columns or answers options, should describe the whole group */
  public categoryName: string;
  /** Title for answers if question is multi-options, should describe the whole group of answers */
  public subcategoryName: string;
  /** Kind of question, if question is multi-options should be 'columna', else it should be 'fila' */
  public kind: string;
  /** Kind of answers of the question. Can be classified in:
   * 0 : Categorical data
   * 1 : Rating data (can be used as a distribution but also calculate a mean of values)
   * 2 : Continous data
   */
  public kindAnswer: number;
  /** Units' name,What are you measuring? Pesos, kilos, people? */
  public unitsName: string;
  /** Question could be collapsed by expansion factor or by categories (answers) depending of kindAnswer */
  public collapseBy: string;
  /** Expansion factor depending of survey populations */
  public expFactor: string;
  /** This Question should be calculated as relative percentages, meaning that percentages should
   * represent the real quantity of people that answer the question, and not percentage distribution of answers
   * (People could answer YES to many options. Options are not mutually exclusive)
   */
  public relativePercentage: boolean;
  /** Used if question should display only the values for the first answer option (Eg. YES answers) */
  public filterFirst: boolean;
  /** List of field options used in axes, grouped by options and filters.
   * Depends on deaggregation options of the question
   */
  public fieldOptions: {slug: string; name: string; options: {field: string; name: string}[] }[];

  /** Inits a question properties based on an object */
  constructor(obj: Object) {
    this._id = obj['_id'];
    this.active = obj['active'];
    this.questionId = obj['questionId'];
    this.qNumber2017 = obj['qNumber2017'];
    this.qNumber2018 = obj['qNumber2018'];
    this.Ambito = obj['Ambito'];
    this.grupos = obj['grupos'];
    this.topic = obj['topic'];
    this.subtopic = obj['subtopic'];
    this.question = obj['question'];
    this.comment = obj['comment'];
    this.sortName = obj['sortName'];
    this.shortName = obj['shortName'];
    this.categoryName = obj['categoryName'];
    this.subcategoryName = obj['subcategoryName'];
    this.kind = obj['kind'];
    this.kindAnswer = obj['kindAnswer'];
    this.unitsName = obj['unitsName'];
    this.collapseBy = obj['collapseBy'];
    this.expFactor = obj['expFactor'];
    this.fieldOptions = obj['fieldOptions'];
    this.topicPerfiles = obj['topicPerfiles'];
    if (obj['relativePercentage']) {
      this.relativePercentage = obj['relativePercentage'] ? true : false;
    }
    if (obj['filterFirst']) {
      this.filterFirst = obj['filterFirst'] ? true : false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/models/question.class.ts